import React, { useCallback, useEffect, useState } from 'react';
import { Row } from 'reactstrap';

import Pagination from 'components/Pagination';
import Loader from 'components/Loader';
import FilterLeadsForm from './components/FilterLeadsForm';
import ListLeadsTable from './components/ListLeadsTable';

import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { useListLeads } from '../../../hooks/useListLeads';

import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useListLeadStagesByRecordType } from 'views/CRM/LeadStages/hooks/useListLeadStagesByRecordType';
import { toast } from 'react-toastify';
import leadService from 'views/CRM/Lead/services/leadService';
import LeadService from '../../../services/leadService';

import ConvertLeadModal from 'views/CRM/Lead/form/LeadDetails/ConvertLeadModal';
import { formatCustomFieldsToDisplay } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { InfoCardLead } from './components/InfoCardLead';
import ChangeResponsibleModal from './components/ChangeResponsibleModal';
import { KanbanRefactor } from '../../../../Opportunity/list/components/OpportunitiesList/components/KanbanRefactor';

const LeadCRM = ({
  selectedRecordTypeId,
  setSelectedRecordType,
  recordTypes
}) => {
  const [activePage, setActivePage] = useState(1);
  const [filters, setFilters] = useState({});
  const [showTable, setShowTable] = useState(true);
  const [controlFunction, setControlFunction] = useState(() => {});

  const { leadStages, getLeadStagesByRecordType } =
    useListLeadStagesByRecordType();

  const [isConvertLeadModalOpen, setIsConvertLeadModalOpen] = useState(false);
  const [lead, setLead] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [transferLeads, setTransferLeads] = useState(false);
  const [isChangeResponsibleModalOpen, setIsChangeResponsibleModalOpen] =
    useState(false);
  const [transferColumnsSearch, setTransferColumnsSearch] = useState({});

  const [searchFiltersData, setSearchFiltersData] = useState({});
  const [kanbanData, setKanbanData] = useState({});
  const [stagePageInfo, setStagePageInfo] = useState([]);

  const [isLoadingKanban, setIsLoadingKanban] = useState(false);

  useEffect(() => {
    getLeadStagesByRecordType(selectedRecordTypeId);
  }, [getLeadStagesByRecordType, selectedRecordTypeId]);

  const {
    getLeads,
    leads,
    totalLeads,
    isLoadingLeads,
    clearLeads,
    getAndReturnLeads
  } = useListLeads({
    recordTypeId: selectedRecordTypeId
  });

  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.LEAD,
    selectedRecordTypeId
  );

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    clearLeads(clearLeads);
    setActivePage(1);
  }, [selectedRecordTypeId, clearLeads]);
  const handleSearchKanban = (searchFilters) => {
    const stages = leadStages || [];
    const filteredStages = stages.filter((stage) => {
      return stage.name !== 'Sem Status';
    });

    const promises = filteredStages.map(async (stage) => {
      return getAndReturnLeads(1, {
        ...searchFilters,
        stageId: stage.id
      });
    });
    Promise.all(promises).then((responses) => {
      const dataObj = {};

      responses.forEach((response) => {
        const stageId = response.config.params.stageId;
        dataObj[stageId] = response.data.data;
      });

      const stageInfo = [];

      responses.forEach((response) => {
        const stage = leadStages.find(
          (stage) => stage.id === response.config.params.stageId
        );
        stageInfo.push({
          id: stage.id,
          name: stage.name,
          count: response.data.totalRegisters,
          currentPage: response.config.headers.page
        });
      });

      setStagePageInfo(stageInfo);

      setKanbanData(dataObj);
    });
    return;
  };

  const handleSearch = useCallback(
    (searchFilters, getAll = false) => {
      setSearchFiltersData(searchFilters);
      setActivePage(1);
      setFilters(searchFilters);
      if (getAll) {
        handleSearchKanban(searchFilters);
        return;
      }
      getLeads(1, searchFilters);
    },
    [getLeads, leadStages, handleSearchKanban]
  );

  const handleTransferSearch = () => {
    handleSearch(transferColumnsSearch);
  };

  const handlePageChange = (newPage) => {
    setActivePage(newPage);
    getLeads(newPage, filters);
  };

  const onTableGrow = async (stageId) => {
    if (isLoadingKanban) return;
    setIsLoadingKanban(true);
    try {
      const page = stagePageInfo.find(
        (item) => item.id === stageId
      ).currentPage;
      if (!page) {
        return;
      }
      const response = await getAndReturnLeads(page + 1, {
        ...searchFiltersData,
        stageId: stageId
      });

      setKanbanData((prev) => {
        const copy = { ...prev };
        copy[stageId] = [...copy[stageId], ...response.data.data];
        return copy;
      });
      setStagePageInfo((prev) => {
        const copy = [...prev];
        copy.forEach((item) => {
          if (item.id === stageId) {
            item.currentPage = page + 1;
          }
        });
        return copy;
      });
      setIsLoadingKanban(false);
    } catch (error) {}
  };

  const reloadLeads = useCallback(() => {
    getLeads(1, {});
  }, [getLeads]);

  const onTableChange = async (
    leadId,
    newStageId,
    isConversion,
    oldStageId
  ) => {
    if (isConversion) {
      const leadData = (await LeadService.getById(selectedRecordTypeId, leadId))
        ?.data?.data;
      if (!leadData) {
        toast.error('Ocorreu um erro ao atualizar a fase');
        return false;
      }
      const formattedLead = formatCustomFieldsToDisplay(leadData, customFields);
      setLead(formattedLead);
      setIsConvertLeadModalOpen(true);

      return new Promise((resolve, reject) => {
        resolve(true);
        reject(false);
      });
    }

    try {
      await leadService.updateStage(leadId, { stageId: newStageId });

      const oldStage = oldStageId;
      const newStage = newStageId;
      const oldStageInfo = stagePageInfo.find((item) => item.id === oldStage);
      const newStageInfo = stagePageInfo.find((item) => item.id === newStage);

      if (!oldStageInfo || !newStageInfo) {
        toast.error('Ocorreu um erro ao buscar informações da fase');
        return false;
      }

      const resultOld = await getAndReturnLeads(
        1,
        {
          ...searchFiltersData,
          stageId: oldStage
        },
        oldStageInfo.currentPage * 20
      );

      const resultNew = await getAndReturnLeads(
        1,
        {
          ...searchFiltersData,
          stageId: newStage
        },
        newStageInfo.currentPage * 20
      );

      if (!resultOld || !resultNew) {
        toast.error('Ocorreu um erro ao atualizar a fase');
        return false;
      }

      setKanbanData((prev) => {
        const copy = { ...prev };
        copy[oldStage] = resultOld.data.data;
        copy[newStage] = resultNew.data.data;
        return copy;
      });

      setStagePageInfo((prev) => {
        const copy = [...prev];
        copy.forEach((item) => {
          if (item.id === oldStage) {
            item.count = resultOld.data.totalRegisters;
          }
          if (item.id === newStage) {
            item.count = resultNew.data.totalRegisters;
          }
        });
        return copy;
      });

      return true;
    } catch (err) {
      console.log('err: ', err);
      toast.error('Ocorreu um erro ao atualizar a fase');
      return false;
    }
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(selectedRows.filter((x) => x.id !== row.id));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const allRows = rows.map((r) => {
      return r;
    });
    if (isSelect) {
      setSelectedRows(allRows);
    } else {
      setSelectedRows([]);
    }
  };

  return (
    <>
      <ConvertLeadModal
        isModalOpen={isConvertLeadModalOpen}
        onModalToggle={setIsConvertLeadModalOpen}
        lead={lead}
        isKanban={true}
        callBackFunc={controlFunction}
      />
      <FilterLeadsForm
        handleSearch={handleSearch}
        customFields={customFields}
        isLoadingLeads={isLoadingLeads}
        recordTypeId={selectedRecordTypeId}
        showTable={showTable}
        setShowTable={setShowTable}
        setTransferLeads={setTransferLeads}
        transferLeads={transferLeads}
        setIsChangeResponsibleModalOpen={setIsChangeResponsibleModalOpen}
        leads={leads}
        selectedRows={selectedRows}
        totalLeads={totalLeads}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
        setTransferColumnsSearch={setTransferColumnsSearch}
      />

      <Row style={{ height: '33.75rem' }} className="mt-2">
        {isLoadingLeads ? (
          <div className="col-12">
            <Row className="justify-content-md-center">
              <Loader />
            </Row>
          </div>
        ) : showTable ? (
          <ListLeadsTable
            leads={leads}
            reloadLeads={reloadLeads}
            selectedRows={selectedRows}
            handleOnSelect={handleOnSelect}
            handleOnSelectAll={handleOnSelectAll}
            transferLeads={transferLeads}
            customFields={customFields}
          />
        ) : (
          <KanbanRefactor
            onTableChange={onTableChange}
            data={Object.values(kanbanData).flat()}
            opportunityStages={leadStages ?? []}
            setControlFunction={setControlFunction}
            InfoCard={InfoCardLead}
            onTableGrow={onTableGrow}
            stagePageInfo={stagePageInfo}
          ></KanbanRefactor>
        )}
      </Row>
      {showTable && (
        <div style={{ marginTop: transferLeads ? '8rem' : '3rem' }}>
          <Pagination
            activePage={activePage}
            totalItemsCount={totalLeads}
            onChange={handlePageChange.bind(this)}
          />
        </div>
      )}
      <ChangeResponsibleModal
        isModalOpen={isChangeResponsibleModalOpen}
        onModalToggle={setIsChangeResponsibleModalOpen}
        leadIds={selectedRows}
        callback={handleTransferSearch}
      />
    </>
  );
};

export default LeadCRM;
